// OrderType Action Types
export const FETCH_ORDER_TYPE_REQUEST = 'FETCH_ORDER_TYPE_REQUEST';
export const FETCH_ORDER_TYPE_SUCCESS = 'FETCH_ORDER_TYPE_SUCCESS';
export const FETCH_ORDER_TYPE_FAILURE = 'FETCH_ORDER_TYPE_FAILURE';

export const ADD_ORDER_TYPE_REQUEST = 'ADD_ORDER_TYPE_REQUEST';
export const ADD_ORDER_TYPE_SUCCESS = 'ADD_ORDER_TYPE_SUCCESS';
export const ADD_ORDER_TYPE_FAILURE = 'ADD_ORDER_TYPE_FAILURE';

export const UPDATE_ORDER_TYPE_REQUEST = 'UPDATE_ORDER_TYPE_REQUEST';
export const UPDATE_ORDER_TYPE_SUCCESS = 'UPDATE_ORDER_TYPE_SUCCESS';
export const UPDATE_ORDER_TYPE_FAILURE = 'UPDATE_ORDER_TYPE_FAILURE';

export const DELETE_ORDER_TYPE_REQUEST = 'DELETE_ORDER_TYPE_REQUEST';
export const DELETE_ORDER_TYPE_SUCCESS = 'DELETE_ORDER_TYPE_SUCCESS';
export const DELETE_ORDER_TYPE_FAILURE = 'DELETE_ORDER_TYPE_FAILURE';

export const ORDER_TYPE_FORM_ERROR = 'ORDER_TYPE_FORM_ERROR';
export const ORDER_TYPE_FORM_SUCCESS = 'ORDER_TYPE_FORM_SUCCESS';
export const SET_ORDER_TYPE_EDIT = 'SET_ORDER_TYPE_EDIT';
export const CLEAR_ORDER_TYPE_EDIT = 'CLEAR_ORDER_TYPE_EDIT'; 